var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("default",null,null,attrs)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }